import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import {Router} from "@angular/router";
import {FUIModalsService} from "@fedelta-pos/ui";
import {AuthApiService} from "../../auth/auth-api.service";
import {Subscription} from "rxjs";


@Component({
    selector: "fhm-app-payment-account-page-modal",
    styleUrls: ["./app-payment-account-page-modal.component.scss"],
    templateUrl: "./app-payment-account-page-modal.component.html",
    providers: [AuthApiService],
    standalone: false
})
export class AppPaymentAccountPageModalComponent implements OnInit, AfterViewInit, OnDestroy {

    @Output() closed: EventEmitter<any> = new EventEmitter();

    state: boolean = true;


    subscriptions: Subscription = new Subscription();

    url: string;

    constructor(private modalsService: FUIModalsService,
                private router: Router,
                private changeDetectorRef: ChangeDetectorRef) {

    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }


    cancel(): void {
        this.closed.emit();
        this.modalsService.close(this);
    }


    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }

    async init(url: string): Promise<void> {
        this.url = url;
    }
}
